import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, ButtonGroup, OverlayTrigger, Popover } from 'react-bootstrap';
import SessionStore from 'stores/SessionStore';
import { ACCEPTED } from 'constants/JobStatus';
import { withTranslation, Translation, Trans } from 'react-i18next';
const MIN_CANCELLATION_LEAD_TIME_MIN = 180;
function getCancelOverlay() {
    return (React.createElement(Popover, { id: "cancel-popover" },
        React.createElement(Translation, null, (t) => React.createElement("p", null, t('SHIPMENT_CAN_NOT_CANCEL_WITH_CARRIER'))),
        React.createElement(Translation, null, (t) => React.createElement("p", null, t('CONTACT_CARGOMATIC_SUPPORT_FOR_CANCELLATION')))));
}
class Cancel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancelToggled: false,
        };
    }
    canCancelAsCarrier() {
        const { job: { current_status, pickup_after: pickupAfter }, } = this.props;
        const now = moment();
        const pickup_after = moment(pickupAfter);
        const pickupTimeWithinCancelRange = pickup_after.diff(now, 'minutes') > MIN_CANCELLATION_LEAD_TIME_MIN;
        if (current_status === ACCEPTED && pickupTimeWithinCancelRange) {
            return true;
        }
        return false;
    }
    canCancelAsShipper() {
        return !this.props.job.carrier;
    }
    canCancelShipment() {
        if (!SessionStore.isShipper() && this.canCancelAsCarrier()) {
            return true;
        }
        if (SessionStore.isShipper() && this.canCancelAsShipper()) {
            return true;
        }
        return false;
    }
    renderConfirmation() {
        const { t } = this.props;
        if (!this.state.cancelToggled) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement("p", null,
                React.createElement(Trans, { i18nKey: "CANCEL_SHIPMENT_CONFIRMATION", values: {
                        shipment_id: this.props.job.shipment_id,
                    }, components: [React.createElement("strong", null)] })),
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { onClick: () => this.setState({ cancelToggled: false }) }, t('NO')),
                React.createElement(Button, { bsStyle: "danger", onClick: () => this.props.onCancelShipment({
                        message: '',
                    }) }, t('YES_CANCEL_SHIPMENT')))));
    }
    renderCancelButton(canCancel) {
        const { t } = this.props;
        return (React.createElement("span", { className: "cancel-btn-wrapper" },
            React.createElement("button", { className: "button button-red", disabled: !canCancel, onClick: () => this.setState({ cancelToggled: true }) }, t('CANCEL_SHIPMENT'))));
    }
    render() {
        const canCancel = this.canCancelShipment();
        return (React.createElement("section", null,
            !this.state.cancelToggled && !canCancel && (React.createElement(OverlayTrigger, { placement: "right", trigger: ['hover', 'focus'], overlay: getCancelOverlay() }, this.renderCancelButton(canCancel))),
            !this.state.cancelToggled &&
                canCancel &&
                this.renderCancelButton(canCancel),
            this.state.cancelToggled && this.renderConfirmation()));
    }
}
Cancel.propTypes = {
    job: PropTypes.shape({
        shipment_id: PropTypes.string.isRequired,
        current_status: PropTypes.string.isRequired,
    }).isRequired,
    onCancelShipment: PropTypes.func.isRequired,
};
export default withTranslation()(Cancel);
